import React, { Fragment, useEffect, useState } from "react";
import "./Applications.css";
import { Accordion, AccordionBody, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import Stepper from "react-stepper-horizontal";
import Model from "../../components/model/Model";
import { useLocation, useNavigate } from "react-router";
import { decryptData } from "../../utils/helper";
import moment from "moment";
import { addApplicationForm, createApplicationActivity, getApplicationById, resetAgreement, updateApplication } from "../../api/Applications";
import { failed, success } from "../../utils/Tostify";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader/Loader";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
import Signature from "./Signature";
import Tasks from "./Tasks/Tasks";
import AddApplicationFormModal from "./Forms/AddApplicationForm";
import { handleFileUpload } from "../../utils/ImageToBase64";
import ReceiptView from "./Receipts/View";
import AddApplicationDocumentModal from "./Documents/AddDocument";
import AddText from "./TextMessages/AddText";
import ComposeMessage from "./TextMessages/ComposeMessage";
import { enrollmentCodeOptions, enrollmentOptions } from "../patient/Constant";
import TextInput from "../../components/InputFields/TextInput";
import { getPatientById, getPatientDocuments, updatePatientById, uploadOrUpdateDocument } from "../../api/patient";
import { FormControl, MenuItem, Select } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import ApplicatioActivity from "./Activity/ApplicatioActivity";
import { ActivityDetails, platformLayout } from "../../utils/constants";
import PdfViewer from "../../components/PdfViewer/PdfViewer";
import { formStatus, stageStatusOption, statusFormOptions, statusFormWithoutSignatureOptions } from "./Constant";
import { decryptPatientData } from "../../utils/common";
import DatePickerSelector from "../../components/InputFields/DatePicker";

function ApplicationDetailPage() {
    let token = useSelector((state) => state.userReducer.token);
    let role = localStorage.getItem("userRole");
    const isPatient = role === "Patient";
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch  = useDispatch();
    const [EnableEditing, setEnableEditing] = useState({latestUpdate : true, latestCaseNote : true});
    const applicationIdFromState = location.state?.id;
    const app = location?.state?.applicationData;
    const appId = location?.state?.applicationData?._id || applicationIdFromState;
    const [application, setApplication] = useState(app);
    const [formEditingIndex, setFormEditingIndex] = useState(null);
    const [formTitle, setFormTitle] = useState('');
    const [docEditingIndex, setDocEditingIndex] = useState(null);
    const [docTitle, setDocTitle] = useState('');
    const [open, setOpen] = useState('1');
    const [isLoading, setIsLoading] = useState(false);
    const [showFormModal, setShowAddFormModal] = useState(false);
    const [showDocModal, setShowAddDocModal] = useState(false);
    const [notesData, setNotesData] = useState({latestUpdate : application?.latestUpdate || "", latestCaseNote: application?.latestCaseNote || ""});
    const [childStages, setChildStages] = useState({});
    const [openModel, setOpenModel] = useState(false);
    const { getConfirmation } = useConfirmDialog();
    const [isComposeText, setIsComposeText] = useState(false);
    const [deniedReason, setDeniedReason]= useState("");
    const [showPdfViewModal, setShowPdfViewModal] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState([]);
    const [formData, setFormData] = useState({});
    const [deniedCode, setDeniedCode] = useState(null);
    const [patientDocuments, setPatientDocumentList] = useState([]);
    const [pdfUrl, setPdfUrl] = useState("");
    const user = useSelector((state) => state?.userReducer?.user);
    const [patientDetails, setPatientDetails] = useState();

    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };
    const [activeTab, setActiveTab] = useState(location.state.activeTab ? location.state.activeTab : '1');
    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    useEffect(() => {
      if (application) {
        setNotesData({
          latestCaseNote: application?.latestCaseNote || "",
          latestUpdate : application?.latestUpdate || ""
        });
      }
    }, [application]);

    const handleStepClick = (data, index) => {
        setChildStages({...data,index});
        setOpenModel(true);
    };
    const getApplication = async () => {
        let res;
        try {
          setIsLoading(true);
          res = await getApplicationById({ dispatch, token, applicationId: appId });
          const responseData = decryptData(res?.data);
          if (res?.status === "SUCCESS") {
            setApplication(responseData);
            setDeniedReason(responseData?.patientData?.medicaidDeniedReason && decryptData(responseData?.patientData?.medicaidDeniedReason));
            setDeniedCode(responseData?.patientData?.medicaidDeniedCode);
            setIsLoading(false);
          }
        } catch (error) {
          failed(res?.message);
          setIsLoading(false);
        }
    };

    const handleSaveClick = async(applicationId, noteType)=>{
        let values;
        if (noteType === "latestUpdate") {
          values = { latestUpdate: notesData.latestUpdate };
        } else if (noteType === "latestCaseNote") {
          values = { latestCaseNote: notesData.latestCaseNote };
        } else if (noteType === "medicaidCaseNumber") {
          values = { medicaidCaseNumber: application?.medicaidCaseNumber };
        }
        let response;
        try {
            setIsLoading(true);
            response = await updateApplication({values, dispatch, token, applicationId});
            if (response?.status === "SUCCESS") {
              let values = {
                type : "Application",
                event : ActivityDetails?.NotesAdded.event,
                applicationId : applicationId,
                clinicId: localStorage.getItem("currentHospitalId"),
                organizationId: localStorage.getItem("currentOrgId"),
                patientId : application?.patientData?._id,
                details : ActivityDetails?.NotesAdded.details
              };
                await createApplicationActivity({ values, dispatch, token });
              // if(res?.status == "SUCCESS"){
                  await getApplication();
                  noteType == "latestUpdate" ? setEnableEditing({...EnableEditing, latestUpdate : true}) : setEnableEditing({...EnableEditing, latestCaseNote : true});
                  setNotesData({latestCaseNote : "", latestUpdate : ""});
                  setIsLoading(false);
                  success(response?.message);
              // }
              // else{
              //   setIsLoading(false);/////
              //   failed(response?.message);
              // }
            }else {
                setIsLoading(false);
                failed(response?.message);
            }
        } catch (error) {
            failed(response?.message);
            setIsLoading(false);
        }
    };

    const handleDeleteClick = async (applicationId, noteType) => {
        let values;
        if(noteType == "latestUpdate"){
            values = {latestUpdate: ""};
        }else{
            values = {latestCaseNote: ""};
        }
        let res;
        try {
          const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: "Are you sure you want to delete the note?"
          });
          if (confirmed) {
            setIsLoading(true);
            res = await updateApplication({ values, dispatch, token, applicationId });
            if (res?.status === "SUCCESS") {
              await getApplication();
              setIsLoading(false);
              success(res?.message);
            } else {
              setIsLoading(false);
              failed(res?.message);
            }
          }
        } catch (error) {
          setIsLoading(false);
          failed(error?.message || "An error occurred");
        }
    };

    const handleStage = async (status) => {
      const currentDate = moment().format("MM-DD-YYYY");
      let res;
      try {
        const confirmed = await getConfirmation({
          title: "Attention!",
          entryName: "",
          actionBtnTitle: "Yes",
          message: status === "Approved" ? "Are you sure you want to mark all stages as completed." : "Are you sure you want to mark Application as Not Approved."
        });
        if (confirmed) {
          const updatedStages = application?.stages?.map(stage => {
            // If the status is "Approved", mark everything as "Approved"
            if (status === "Approved") {
              const updatedChildren = stage.child.map(child => ({
                ...child,
                status: "Approved",
                completionDate: currentDate
              }));
              return {
                ...stage,
                status: "Approved",  // Mark parent stage as "Approved"
                child: updatedChildren // Mark all child stages as "Approved"
              };
            }
            // If the status is "Not Approved", mark everything except already "Approved"
            const updatedChildren = stage.child.map(child => ({
              ...child,
              status: child.status === "Approved" ? "Approved" : "NotApproved" // Keep "Approved" status, otherwise mark "Not Approved"
            }));
            return {
              ...stage,
              status: stage.status === "Approved" ? "Approved" : "NotApproved", // Keep "Approved" status, otherwise mark "Not Approved"
              child: updatedChildren
            };
          });
          const values = { stages: updatedStages, status };
          setIsLoading(true);
          res = await updateApplication({ values, dispatch, token, applicationId: application?._id });
          if (res?.status === "SUCCESS") {
            let values = {
              type : "Application",
              event : ActivityDetails?.NotesAdded.event,
              applicationId : application?._id,
              clinicId: localStorage.getItem("currentHospitalId"),
              organizationId: localStorage.getItem("currentOrgId"),
              patientId : application?.patientData?._id,
              details : ActivityDetails?.StageUpdate.details
            };
            await createApplicationActivity({ values, dispatch, token });
            await getApplication();
            setIsLoading(false);
            // success(res?.message);
          } else {
            setIsLoading(false);
            failed(res?.message);
          }
        }
      } catch (error) {
        setIsLoading(false);
        failed(error?.message || "An error occurred");
      }
    };

    const handleFormEditClick = (index, currentTitle) => {
      setFormEditingIndex(index); // Set the index of the form being edited
      setFormTitle(currentTitle);
    };

    const handleFormTitleChange = (e) => {
      setFormTitle(e.target.value);
    };
    const handleFormTitleSaveClick = async(index, formId) => {
      let res;
      try {
        const updatedApplicationForm = application.applicationForms.map((form)=> {
          if(form._id === formId){
            return {
              ...form,
              formTitle : formTitle
            };
          }
          return form;
        });
        const values = {applicationForms : updatedApplicationForm};
        setIsLoading(true);
        res = await updateApplication({values, dispatch, token, applicationId : application?._id});
        if (res?.status === "SUCCESS") {
            setFormEditingIndex(null);
            await getApplication();
            setIsLoading(false);
            success(res?.message);
        }else {
            setIsLoading(false);
            failed(res?.message);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
    };

    const handleFormDelete = async(index, formId, formTitle) => {
      let res;
      try {
        const confirmed = await getConfirmation({
          title: "Attention!",
          entryName: "",
          actionBtnTitle: "Yes",
          message: `Are you sure you want to Delete ${formTitle}`
        });
        if(confirmed){
          const updatedApplicationForm = application.applicationForms.filter((form)=> form?._id != formId);
          const values = {applicationForms : updatedApplicationForm};
          setIsLoading(true);
          res = await updateApplication({values, dispatch, token, applicationId : application?._id});
          if (res?.status === "SUCCESS") {
              setFormEditingIndex(null);
              await getApplication();
              setIsLoading(false);
              success(res?.message);
          }else {
              setIsLoading(false);
              failed(res?.message);
          }
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
    };

    const handleDocEditClick = (index, currentTitle) => {
      setDocEditingIndex(index); // Set the index of the form being edited
      setDocTitle(currentTitle);
    };

    const handleDocTitleChange = (e) => {
      setDocTitle(e.target.value);
    };
    const handleDocTitleSaveClick = async(index, docId) => {
      let res;
      try {
        const values = {title : docTitle};
        setIsLoading(true);
        res = await uploadOrUpdateDocument({values, dispatch, token, patientId: application?.patientData?._id, documentId : docId});
        if (res?.status === "SUCCESS") {
            setDocEditingIndex(null);
            await getApplication();
            setIsLoading(false);
            success(res?.message);
        }else {
            setIsLoading(false);
            failed(res?.message);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
    };

    const handleDocDelete = async(docId, docTitle) => {
      let res;
      try {
        const confirmed = await getConfirmation({
          title: "Attention!",
          entryName: "",
          actionBtnTitle: "Yes",
          message: `Are you sure you want to Delete ${docTitle}`
        });
        if(confirmed){
          const updatedApplicationDoc = application.applicationDocuments.filter((form)=> form?._id != docId);
          const formattedDocs = updatedApplicationDoc.map(doc => ({
            _id: doc._id,  // or generate a new id if required
            documentId: doc.documentId,
            documentTypeId: doc.documentTypeId
        }));
          const values = {applicationDocuments : formattedDocs};
          setIsLoading(true);
          res = await updateApplication({values, dispatch, token, applicationId : application?._id});
          if (res?.status === "SUCCESS") {
              setDocEditingIndex(null);
              await getApplication();
              setIsLoading(false);
              success(res?.message);
          }else {
              setIsLoading(false);
              failed(res?.message);
          }
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
    };

    const handleFileSelect = (event, formId, docId, type) => {
      const file = event.target.files[0];
      if (file) {
        (file);
        if(type === "file"){
          handleFileUpdate(file, formId); // Call API to upload the file
        }else{
          handleDocUpdate(file, docId);
        }
      }
    };
    const handleDocUpdate = async(file, docId) => {
      let res;
      try {
        let base64pdfForm = "";
            base64pdfForm = await handleFileUpload(file);
            const fileExtension = file?.type?.split("/")[1];
            const docFile = {
                base64String: base64pdfForm,
                extension: fileExtension, // Add the file extension to the object
                name: file?.name
            };
            const payload = {file : docFile};
        setIsLoading(true);
        res = await uploadOrUpdateDocument({ values : payload, dispatch, token, patientId: application?.patientData?._id, documentId : docId, uploadedBy:user._id, applicationId: application?._id });
        if (res?.status === "SUCCESS") {
          let values = {
            type : "Application",
            event : ActivityDetails?.DocumentUploadDownload?.event,
            applicationId : application?._id,
            clinicId: localStorage.getItem("currentHospitalId"),
            organizationId: localStorage.getItem("currentOrgId"),
            patientId :  application?.patientData?._id,
            details : "Document Uploaded."
          };
          await createApplicationActivity({ values, dispatch, token });
          await getApplication();
          success(res.message);
          setIsLoading(false);
        }else{
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        failed(res?.message);
        setIsLoading(false);
      }
    };
    const handleFileUpdate = async(file, formId) => {
      let res;
      try {
        if(file.type !== "application/pdf"){
          failed("Please select a PDF file");
          return;
        }
        let base64pdfForm = "";
            base64pdfForm = await handleFileUpload(file);
            const fileExtension = file?.type?.split("/")[1];
            const pdfForm = {
                base64String: base64pdfForm,
                extension: fileExtension, // Add the file extension to the object
                name: file?.name
            };
            const payload = {
              formId,
              pdfForm
            };
        setIsLoading(true);
        res = await addApplicationForm({ values : payload, dispatch, token, applicationId: application?._id });
        if (res?.status === "SUCCESS") {
          let values = {
            type : "Application",
            event : ActivityDetails?.DocumentUploadDownload?.event,
            applicationId : application?._id,
            clinicId: localStorage.getItem("currentHospitalId"),
            organizationId: localStorage.getItem("currentOrgId"),
            patientId :  application?.patientData?._id,
            details : "Document Uploaded."
          };
          let res = await createApplicationActivity({ values, dispatch, token });
          await getApplication();
          success(res.message);
          setIsLoading(false);
        }else{
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        failed(res?.message);
        setIsLoading(false);
      }
    };
    const triggerFileInputForm = (index) => {
      document.getElementById(`fileInputForm-${index}`).click(); // Trigger file input
    };
    const triggerFileInputDoc = (index) => {
      document.getElementById(`fileInputDoc-${index}`).click(); // Trigger file input
    };

    useEffect(() => {
        getApplication();
        getPatient();
        getPatientDetail();
    }, [activeTab,appId]);

    const getPatient = async () => {
      let res;
      try {
        setIsLoading(true);
        res = await getPatientDocuments({ dispatch, token, id: application?.patientData?._id});
        const responseData = decryptData(res.data);
        if (res?.status === "SUCCESS") {
          setIsLoading(false);
          setPatientDocumentList(responseData);
        }
      } catch (error) {
        setIsLoading(false);
      }
    };

    const getPatientDetail = async () => {
        let res;
        try {
            setIsLoading(true);
            res = await getPatientById({ dispatch, token, id: application?.patientData._id, userId: user?._id });
            const responseData = decryptData(res.data);
            const decryptedPatient = await decryptPatientData(responseData);
            if (res?.status === "SUCCESS") {
                setPatientDetails(decryptedPatient);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const handleEdit = async (fieldType, updatedValue) => {
      let res;
      let values = {};
      try {
        setIsLoading(true);
        if (fieldType === "archieve") {
          values = { archieve: !patientDetails?.archieve };
        } else if (fieldType === "medicaidSubscriberIDNumber") {
          values = { medicaidSubscriberIDNumber: patientDetails?.medicaidSubscriberIDNumber };
        } else if (fieldType === "medicaidRenewalDate") {
          values = { medicaidRenewalDate: updatedValue || patientDetails?.medicaidRenewalDate };
        }
        res = await updatePatientById({ payload: values, dispatch, token, patientId: patientDetails?._id });
        if (res?.status === "SUCCESS") {
          await getPatientDetail(); // refresh latest patient data
          success(res?.message);
        } else {
          failed(res?.message);
        }
      } catch (error) {
        failed(error?.message || "Something went wrong");
      } finally {
        setIsLoading(false);
      }
    };

    const activeStepIndex =
    application?.stages?.some((stage) => stage.status === "NotApproved")
      ? application?.stages?.findIndex((stage) => stage.status === "NotApproved")
      : application?.stages?.every((stage) => stage.status === "Approved")
      ? application?.stages?.length
      : application?.stages?.findIndex((stage) => stage.status === "InProcess") !== -1
      ? application?.stages?.findIndex((stage) => stage.status === "InProcess")
      : application?.stages?.findIndex((stage) => stage.status === "NotStarted") !== -1
      ? application?.stages?.findIndex((stage) => stage.status === "NotStarted")
      : application?.stages?.length - 1;

  const handleSavePatientClick = async (patientId, payload) => {
          let res;
          try {
            setIsLoading(true);
            res = await updatePatientById({ payload, dispatch, token, patientId });
            if (res?.status === "SUCCESS") {
              let values = {
                type : "Application",
                event : payload?.medicaidEnrollmentStatus ? ActivityDetails?.MedicaidEnrollmentStatusUpdate.event : payload?.medicaidDeniedCode ? ActivityDetails?.DenialReasonCodeUpdate.event : payload?.medicaidDeniedReason ?  ActivityDetails?.DenialReasonNoteUpdate.event : "",
                applicationId : application?._id,
                clinicId: localStorage.getItem("currentHospitalId"),
                organizationId: localStorage.getItem("currentOrgId"),
                patientId : patientId,
                details : payload?.medicaidEnrollmentStatus ? ActivityDetails?.MedicaidEnrollmentStatusUpdate.details : payload?.medicaidDeniedCode ? ActivityDetails?.DenialReasonCodeUpdate.details : payload?.medicaidDeniedReason ?  ActivityDetails?.DenialReasonNoteUpdate.details : ""
              };
              await createApplicationActivity({ values, dispatch, token });
              await getApplication();
              setIsLoading(false);
              success(res?.message);
            } else {
              setIsLoading(false);
              failed(res?.message);
            }
          } catch (error) {
            failed(res?.message);
            setIsLoading(false);
          }
  };

    const handleDownloadForm = async(url)=>{
      window.open(url);
      let values = {
        type : "Application",
        event : ActivityDetails?.DocumentUploadDownload?.event,
        applicationId : application?._id,
        clinicId: localStorage.getItem("currentHospitalId"),
        organizationId: localStorage.getItem("currentOrgId"),
        patientId :  application?.patientData?._id,
        details : "Form downloaded"
      };
      await createApplicationActivity({ values, dispatch, token });
    };

    const handleDownloadDocument = async(url)=>{
      window.open(url);
      let values = {
        type : "Application",
        event : ActivityDetails?.DocumentUploadDownload?.event,
        applicationId : application?._id,
        clinicId: localStorage.getItem("currentHospitalId"),
        organizationId: localStorage.getItem("currentOrgId"),
        patientId :  application?.patientData?._id,
        details : "Document downloaded"
      };
      await createApplicationActivity({ values, dispatch, token });
    };

    const handleChangeStatus = async (e, formId, key) => {
      let res;
      try {
        const isChecked = e.target.checked;
        e.target.checked = !isChecked;

        const msg = isChecked ? "Activate" : "Deactivate";
        const confirmed = await getConfirmation({
          title: "Attention!",
          entryName: "",
          actionBtnTitle: "Yes",
          message: `Are you sure you want to ${msg} ${key === "lockStatus" ? "Lock Status" : "Signature Required"}?`
        });
        if (confirmed) {
          // Use Promise.all to handle async operations inside map
          const updatedApplicationForm = await Promise.all(
            application.applicationForms.map(async (form) => {
              if (form._id === formId) {
                const updatedForm = {
                  ...form,
                  [key]: isChecked
                };

                if (key === "signatureRequired" && !isChecked) {
                  updatedForm.status = formStatus.IN_PROGRESS;
                  updatedForm.agreementId = null;

                  // Reset agreement if `agreementId` exists
                  if (form.agreementId) {
                    const values = {
                      applicationId: application?._id,
                      formId,
                      agreementId: form.agreementId
                    };
                    await resetAgreement({ values, dispatch, token });
                  }
                }
                return updatedForm;
              }
              return form;
            })
          );

          const values = { applicationForms: updatedApplicationForm };
          setIsLoading(true);

          res = await updateApplication({
            values,
            dispatch,
            token,
            applicationId: application?._id
          });
          if (res?.status === "SUCCESS") {
            await getApplication();
            setIsLoading(false);
            success(res?.message);
          } else {
            setIsLoading(false);
            failed(res?.message);
          }
        }
      } catch (error) {
        failed(error?.message || "An error occurred.");
        setIsLoading(false);
      }
    };

    const toggleDropdown = (id) => {
      setDropdownOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
    };

    const handlePrepareForm = async(payload, formId) => {
      let res;
      try {
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure you want to change?`
        });
        if (confirmed) {
        const updatedApplicationForm = application.applicationForms.map((form)=> {
          if(form._id === formId){
            return {
              ...form,
              ...payload
            };
          }
          return form;
        });
        const values = {applicationForms : updatedApplicationForm};
        setIsLoading(true);
        res = await updateApplication({values, dispatch, token, applicationId : application?._id});
        if (res?.status === "SUCCESS") {
            if(payload.status === formStatus.READY_TO_SIGN){
              setActiveTab("6");
            }
            await getApplication();
            setIsLoading(false);
            success(res?.message);
        }else {
            setIsLoading(false);
            failed(res?.message);
        }
      }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
    };

  //if not comment then Appln tab works perfectly but if commnet then not works in patient
  useEffect(()=>{
    localStorage.removeItem("prevRoute2");
  },[]);

  const handleDocDateChange = async (date, docId) => {
    if (!date || !docId) return;

    try {
      setIsLoading(true);

      const values = {
        expirationDate: moment(date).format("YYYY-MM-DD")
      };

      const res = await uploadOrUpdateDocument({
        values,
        dispatch,
        token,
        patientId: application?.patientData?._id,
        documentId: docId
      });

      if (res?.status === "SUCCESS") {
        await getApplication();
        success(res.message);
      } else {
        failed(res.message);
      }
    } catch (error) {
      failed("Failed to update expiration date.");
    } finally {
      setIsLoading(false);
    }
  };


    const prevRoute2 = localStorage.getItem("prevRoute2");

    return (
      <Fragment>
      <div className="application_details applications-container p-2 profile_main_two">
        {openModel ? (<Model refetch={getApplication} applicationData={childStages} modal={openModel} handleClose={() => setOpenModel(false)} className={"stepper_modal"}/>) : null}
        {showFormModal ? <AddApplicationFormModal refetch={getApplication} setShowModal={()=> setShowAddFormModal(!showFormModal)} applicationId={application?._id} patientId={application?.patientData?._id}/> : null}
        {showDocModal ? <AddApplicationDocumentModal refetch={getApplication} setShowModal={()=> setShowAddDocModal(!showDocModal)} patientApplication={application} applicationId={application?._id} patientDocuments={patientDocuments}/> : null}
        {showPdfViewModal ? <PdfViewer url={pdfUrl} formData={formData} setShowModal={()=> !setShowPdfViewModal(!showPdfViewModal)} application={application} is_apl_view={true} refetch={getApplication}/> : null}
        {isLoading ? (<Loader/>) : null}
        <h2 className="home-title">{`Application Information: ${decryptData(application?.patientData?.name[0].text)} - ${application?.title}`}</h2>
        <div className="p-0">
          <Nav tabs className="profile_intab horizontal-scroll d-flex">
            <NavItem>
              <NavLink
                className={activeTab === "1" ? "active" : ""}
                onClick={() => toggleTab("1")}
              >
                Summary
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "2" ? "active" : ""}
                onClick={() => toggleTab("2")}
              >
                Forms
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "3" ? "active" : ""}
                onClick={() => toggleTab("3")}
              >
                Documents
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "4" ? "active" : ""}
                onClick={() => toggleTab("4")}
              >
                Receipts
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "5" ? "active" : ""}
                onClick={() => toggleTab("5")}
              >
                Tasks
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "6" ? "active" : ""}
                onClick={() => toggleTab("6")}
              >
                Signature
              </NavLink>
            </NavItem>
            {!isPatient && (
            <NavItem>
              <NavLink
                className={activeTab === "7" ? "active" : ""}
                onClick={() => toggleTab("7")}
              >
                Text
              </NavLink>
            </NavItem>
            )}
            {!isPatient && (
            <NavItem>
              <NavLink
                className={activeTab === "8" ? "active" : ""}
                onClick={() => toggleTab("8")}
              >
                Activity
              </NavLink>
            </NavItem>
            )}
          </Nav>
        </div>
        <div className="tab-top border-0">
          <div>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <Accordion open={open} toggle={toggle}>
                  <AccordionBody accordionId="1" className="abc">
                    <div className="data_patient">
                      <div className="data_tracker">
                        <Stepper
                          steps={application.stages.map((step, index) => {
                          return {
                            title: (
                              <Tooltip title={step.name} arrow>
                              <div
                                className="stepper-application"
                                style={{
                                  cursor: 'pointer',
                                  pointerEvents: 'auto', // Ensure step is clickable
                                  zIndex: 10 // Ensure it is above other elements
                                }}
                                onClick={() => handleStepClick({ childStages: step , application },index+1)} // Handle step click
                              >
                                <span>{step?.name}</span>
                                {step?.status === "InProcess" && (
                                  <button
                                    style={{
                                      marginLeft: "10px",
                                      backgroundColor: "#335FFC",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "4px",
                                      padding: "4px 6px",
                                      fontWeight:"600",
                                      cursor: "pointer"
                                    }}
                                  >
                                    Current Stage
                                  </button>
                                )}
                                {step?.status === "NotApproved" && (
                                  <button
                                    style={{
                                      marginLeft: "10px",
                                      backgroundColor: "#E44545", // Red for rejected
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "4px",
                                      fontWeight:"600",
                                      padding: "4px 8px",
                                      cursor: "pointer"
                                    }}
                                  >
                                    Not Approved
                                  </button>
                                )}
                              </div>
                              </Tooltip>
                            ),
                            onClick: () => {
                              handleStepClick({ childStages: step, application },index+1);
                            }};
                            })}
                            circleTop={0}
                            lineMarginOffset={10}
                            size={50}
                            activeStep={activeStepIndex}
                            activeColor={application.stages[activeStepIndex]?.status === "NotApproved"
                            ? "#E44545"
                            : application.stages[activeStepIndex]?.status === "InProcess"
                            ? "#ECB800"
                            : application.stages[activeStepIndex]?.status === "NotStarted"
                            ? "#8B8D91"
                            : "#339900"}
                            defaultColor={"#8B8D91"}
                            defaultTitleColor={"#8B8D91"}
                            completeColor="#339900"
                            activeTitleColor={application.stages[activeStepIndex]?.status === "NotApproved"
                            ? "#E44545"
                            : application.stages[activeStepIndex]?.status === "InProcess"
                            ? "#ECB800"  // Yellow title for in-process
                            : application.stages[activeStepIndex]?.status === "NotStarted"
                            ? "#8B8D91"
                            : "#339900"}

                            completeTitleColor="#339900"
                            activeBarColor={application.stages[activeStepIndex]?.status === "NotApproved"
                            ? "#E44545"
                            : application.stages[activeStepIndex]?.status === "InProcess"
                            ? "#ECB800"
                            : application.stages[activeStepIndex]?.status === "NotStarted"
                            ? "#8B8D91"
                            : "#339900"}
                            completeBarColor="#339900"
                        />
                      </div>
                      <div className="row application_details_block application_patient_blk mt-3">
                          <h3 className="title_name mt-0">Application Overview</h3>
                          <div className="col-xl-4 col-lg-4 application_details">
                            <div className="row">
                              <div className="col-3 text-end"><p>Start Date</p></div>
                              <div className="col-1 text-center"><p>:</p></div>
                              <div className="col-8"><p>{moment(application?.createdAt).format("MMM-DD-YYYY")}</p></div>
                            </div>
                          </div>

                          <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Type</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationType?.applicationTitle}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Status</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{stageStatusOption.find(option => option.value === application?.status)?.label || '-'}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-3 text-end"><p>Active Days</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {moment().diff(moment(application?.createdAt), "days") + " Days"}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Consultant</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {application.consultantUser?.[0]
                                  ? `${application.consultantUser?.[0]?.firstName} ${application.consultantUser?.[0]?.lastName}`
                                  : "No Consultant assigned."}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Id</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationID}</p></div>
                          </div>
                        </div>

                        {role !== platformLayout?.Patient && (
                            <Row className="mt-3 align-items-center">
                              <h3 className="title_name mt-1">Primary Applicant</h3>

                              <div className="col-xl-4 col-lg-6 application_details">
                                <div className="row">
                                  <div className="col-3 text-end"><p>Name</p></div>
                                  <div className="col-1 text-center"><p>:</p></div>
                                  <div className="col-7">
                                    <p>
                                      {decryptData(application?.patientData?.name[0].text)}{" "}
                                      <button
                                        className="add_notes"
                                        onClick={() =>
                                          navigate("/clinic/patient-profile", {
                                            state: {
                                              patientData: application?.patientData?._id,
                                              isEditMode: !prevRoute2 ? true : false,
                                              isEditMode2: prevRoute2 === "/clinic/patient-profile",
                                              application: application
                                            }
                                          })
                                        }
                                      >
                                        View Details
                                      </button>
                                    </p>
                                  </div>
                                </div>

                                <div className="row mt-2">
                                  <div className="col-3 text-end"><p>Email ID</p></div>
                                  <div className="col-1 text-center"><p>:</p></div>
                                  <div className="col-7">
                                    <p>
                                      {decryptData(
                                        application?.patientData?.telecom.find((obj) => obj?.system === "email")
                                          ?.value || "-"
                                      )}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 application_details">
                                <div className="row">
                                  <div className="col-4 text-end"><p>Gender</p></div>
                                  <div className="col-1 text-center"><p>:</p></div>
                                  <div className="col-7">
                                    <p>{decryptData(application?.patientData?.gender) || "-"}</p>
                                  </div>
                                </div>

                                <div className="row mt-2">
                                  <div className="col-4 text-end"><p>Status</p></div>
                                  <div className="col-1 text-center"><p>:</p></div>
                                  <div className="col-7">
                                    <p>{decryptData(application?.patientData?.maritalStatus) || "-"}</p>
                                  </div>
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 application_details">
                                <div className="row">
                                  <div className="col-4 text-end"><p>DOB</p></div>
                                  <div className="col-1 text-center"><p>:</p></div>
                                  <div className="col-7">
                                    <p>{decryptData(application?.patientData?.birthDate) || "-"}</p>
                                  </div>
                                </div>

                                <div className="row mt-2">
                                  <div className="col-4 text-end"><p>State</p></div>
                                  <div className="col-1 text-center"><p>:</p></div>
                                  <div className="col-7">
                                    <p>
                                      {application.patientData?.address[0]?.state && decryptData(application.patientData?.address[0]?.state)}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </Row>
                          )}
                        {role !== platformLayout?.Patient && <Row className="mt-3 align-items-center">
                          <h3 className="title_name mt-1">Medicaid Enrollment</h3>
                          <div className="col-md-12 application_details">
                            <p className="d-flex gap-3  align-items-center">
                              Medicaid Enrollment Status :{" "}
                              <span>
                                <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                                  <Select
                                    labelId="demo-select-small-label"
                                    id="demo-select-small"
                                    value={application?.patientData?.medicaidEnrollmentStatus}
                                    onChange={(e) => {
                                      const newStatus = e.target.value;
                                      if (newStatus !== "Denied") {
                                        setDeniedCode("");
                                        setDeniedReason("");
                                        handleSavePatientClick(application?.patientData?._id, {
                                          medicaidEnrollmentStatus: newStatus,
                                          medicaidDeniedCode: "", // Clear denied code
                                          medicaidDeniedReason: "" // Clear denied reason
                                        });
                                      } else {
                                        handleSavePatientClick(application?.patientData?._id, {
                                          medicaidEnrollmentStatus: newStatus
                                        });
                                      }
                                    }}
                                  >
                                  {enrollmentOptions?.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                                </FormControl>
                              </span>
                            </p>
                          </div>
                          {application?.patientData?.medicaidEnrollmentStatus === "Denied" &&
                          <>
                            <div className="col-xl-4 col-lg-6 col-md-12 application_details">
                            <p className="d-flex gap-3  align-items-center">
                                Medicaid Denial Reason Code :{" "}
                                <span>
                                <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                                    <Select
                                      labelId="demo-select-small-label"
                                      id="demo-select-small"
                                      defaultValue={deniedCode}
                                      value={deniedCode}
                                      onChange={(e) => handleSavePatientClick(application?.patientData?._id, {"medicaidDeniedCode": e.target.value})}
                                    >
                                    {enrollmentCodeOptions?.map((option) => (
                                      <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  </FormControl>
                                </span>
                              </p>
                            </div>
                            <div className="col-xl-4 col-md-12 application_details">
                            <p className="d-flex gap-3  align-items-center">
                            Medicaid Denial Reason :{" "}
                            <span>
                            <TextInput
                                keyField={"medicaidDeniedReason"}
                                required={false}
                                type="text"
                                value={deniedReason}
                                onBlur={() =>
                                  handleSavePatientClick(application?.patientData?._id, { "medicaidDeniedReason": deniedReason})
                                }
                                onChange={(e) => setDeniedReason(e.target.value)}
                              />
                              </span>
                              </p>
                            </div>
                          </>}
                        </Row>}

                        <div className="col-xl-4 col-md-12 application_details">
                          <p className="d-flex gap-3 align-items-center">
                            Medicaid Case Number:
                            <span>
                              {isPatient ? (
                                application?.medicaidCaseNumber || "-"
                              ) : (
                                <TextInput
                                  required={false}
                                  type="text"
                                  value={application?.medicaidCaseNumber || ""}
                                  onChange={(e) =>
                                    setApplication((prev) => ({
                                      ...prev,
                                      medicaidCaseNumber: e.target.value
                                    }))
                                  }
                                  onBlur={() =>
                                    handleSaveClick(application?._id, "medicaidCaseNumber")
                                  }
                                />
                              )}
                            </span>
                          </p>
                        </div>

                        <div className="col-xl-4 col-md-12 application_details">
                          <p className="d-flex gap-3 align-items-center">
                            Medicaid Subscriber ID Number:
                            <span>
                              {isPatient ? (
                                patientDetails?.medicaidSubscriberIDNumber || "-"
                              ) : (
                                <TextInput
                                  required={false}
                                  type="text"
                                  value={patientDetails?.medicaidSubscriberIDNumber || ""}
                                  onChange={(e) =>
                                    setPatientDetails((prev) => ({
                                      ...prev,
                                      medicaidSubscriberIDNumber: e.target.value
                                    }))
                                  }
                                  onBlur={() => handleEdit("medicaidSubscriberIDNumber")}
                                />
                              )}
                            </span>
                          </p>
                        </div>

                       <div className="col-xl-4 col-md-12 application_details">
                          <p className="d-flex gap-3 align-items-center">
                            Medicaid Renewal Date:{" "}
                            <span>
                              {isPatient ? (
                                patientDetails?.medicaidRenewalDate
                                  ? moment(patientDetails.medicaidRenewalDate).format("MMM-DD-YYYY")
                                  : "-"
                              ) : (
                                <DatePickerSelector
                                  label=""
                                  value={patientDetails?.medicaidRenewalDate}
                                  onChange={(newDate) => {
                                    setPatientDetails((prev) => ({
                                      ...prev,
                                      medicaidRenewalDate: newDate
                                    }));
                                    handleEdit("medicaidRenewalDate", newDate);
                                  }}
                                />
                              )}
                            </span>
                          </p>
                        </div>

                      </div>
                      <div className="row space_blk flex-wrap gap-0 p-0">
                        <div className="col-6 d-flex gap-2 align-items-center p-0">
                          <Form className="text_block">
                            <Label>
                              Latest Update {role !== platformLayout?.Patient &&
                                `${("This will also be visible to the patient")}`}:
                            </Label>
                            <Input
                              id="exampleText"
                              name="text"
                              type="textarea"
                              className="text_area_blk"
                              defaultValue={application?.latestUpdate}
                              // value={notesData?.latestUpdate ? notesData?.latestUpdate : application?.latestUpdate}
                              value={notesData?.latestUpdate}
                              onChange={(e) => {
                                setNotesData((prev) => ({...prev, latestUpdate: e.target.value}));
                                setEnableEditing({...EnableEditing, latestUpdate: false});
                              }}
                              onClick={() => setEnableEditing({...EnableEditing, latestUpdate: false})}
                              readOnly={isPatient}
                            />
                          </Form>
                          {!isPatient && (
                          <div className="d-flex gap-3">
                            {!EnableEditing.latestUpdate && notesData?.latestUpdate !== application?.latestUpdate ? (
                              <i
                                className="fa fa-floppy-disk"
                                onClick={() => handleSaveClick(application._id, "latestUpdate")}
                              >
                              </i>
                            ) : (
                              <i
                                className="fa fa-edit"
                                onClick={() => setEnableEditing({...EnableEditing, latestUpdate: false})}
                                style={{ cursor: "pointer" }}
                              />
                            )}
                            {application?.latestUpdate !== "" && (
                              <i
                                className="fas fa-trash-alt"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDeleteClick(application._id, "latestUpdate")}
                              />
                            )}
                          </div>
                          )}
                        </div>
                        {role !== platformLayout?.Patient &&
                        <div className="col-6 d-flex gap-2 align-items-center p-2 mt-3">
                          <Form className="text_block">
                            <Label>
                              Latest Application Notes {role !== platformLayout?.Patient &&
                                `${("This is only for internal purposes")}`}:
                            </Label>
                            <Input
                              id="exampleText"
                              name="text"
                              type="textarea"
                              className="text_area_blk"
                              // defaultValue={application?.latestCaseNote}
                              // value={notesData?.latestCaseNote ? notesData?.latestCaseNote : application?.latestCaseNote}
                              value={notesData?.latestCaseNote}
                              onChange={(e) => {
                                setNotesData((prev) => ({...prev, latestCaseNote: e.target.value}));
                                setEnableEditing({...EnableEditing, latestCaseNote: false});
                              }}
                              onClick={() => setEnableEditing({...EnableEditing, latestCaseNote: false})}
                            />
                          </Form>
                          <div className="d-flex gap-3">
                            {!EnableEditing.latestCaseNote && notesData?.latestCaseNote !== application?.latestCaseNote ? (
                              <i
                                className="fa fa-floppy-disk"
                                onClick={() => handleSaveClick(application._id, "latestCaseNote")}
                              >
                              </i>
                            ) : (
                              <i
                                className="fa fa-edit"
                                onClick={() => setEnableEditing({...EnableEditing, latestCaseNote: false})}
                                style={{ cursor: "pointer" }}
                              />
                            )}
                            {application?.latestCaseNote && (
                              <i
                                className="fas fa-trash-alt"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDeleteClick(application._id, "latestCaseNote")}
                              />
                            )}
                          </div>
                        </div>
                        }
                      </div>
                      {role !== platformLayout?.Patient && <div className="edit d-flex gap-2 align-items-center justify-content-center flex-wrap">
                        {application?.stages?.every((stage) => stage.status === "Approved") ? null : <button className="mark_note" onClick={()=> handleStage("Approved")}>Approved</button>}
                        {application?.stages?.every((stage) => stage.status === "Approved") ? null : <button className="mark_note" style={{backgroundColor : "#E44545"}} onClick={()=> handleStage("NotApproved")}>Not Approved</button>}
                      </div>}
                    </div>
                  </AccordionBody>
                </Accordion>
              </TabPane>
              <TabPane tabId="2">
                <Accordion open={open} toggle={toggle}>
                  <AccordionBody accordionId="1" className="form_tab">
                    <div className="data_patient">
                      <div className="row application_details_block application_patient_blk mt-3">
                          <h3 className="title_name mt-0">Application Overview</h3>
                          <div className="col-xl-4 col-lg-4 application_details">
                            <div className="row">
                              <div className="col-3 text-end"><p>Start Date</p></div>
                              <div className="col-1 text-center"><p>:</p></div>
                              <div className="col-8"><p>{moment(application?.createdAt).format("MMM-DD-YYYY")}</p></div>
                            </div>
                          </div>

                          <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Type</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationType?.applicationTitle}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Status</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{stageStatusOption.find(option => option.value === application?.status)?.label || '-'}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-3 text-end"><p>Active Days</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {moment().diff(moment(application?.createdAt), "days") + " Days"}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Consultant</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {application.consultantUser?.[0]
                                  ? `${application.consultantUser?.[0]?.firstName} ${application.consultantUser?.[0]?.lastName}`
                                  : "No Consultant assigned."}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Id</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationID}</p></div>
                          </div>
                        </div>

                        {role !== platformLayout?.Patient &&
                       <Row className="mt-3 align-items-center">
                       <h3 className="title_name mt-1">Primary Applicant</h3>

                       <div className="col-xl-4 col-lg-6 application_details">
                         <div className="row">
                           <div className="col-3 text-end"><p>Name</p></div>
                           <div className="col-1 text-center"><p>:</p></div>
                           <div className="col-7">
                             <p>
                               {decryptData(application?.patientData?.name[0].text)}{" "}
                               <button
                                 className="add_notes"
                                 onClick={() =>
                                   navigate("/clinic/patient-profile", {
                                     state: {
                                       patientData: application?.patientData?._id,
                                       isEditMode: !prevRoute2 ? true : false,
                                       isEditMode2: prevRoute2 === "/clinic/patient-profile",
                                       application: application
                                     }
                                   })
                                 }
                               >
                                 View Details
                               </button>
                             </p>
                           </div>
                         </div>

                         <div className="row mt-2">
                           <div className="col-3 text-end"><p>Email ID</p></div>
                           <div className="col-1 text-center"><p>:</p></div>
                           <div className="col-7">
                             <p>
                               {decryptData(
                                 application?.patientData?.telecom.find((obj) => obj?.system === "email")
                                   ?.value || "-"
                               )}
                             </p>
                           </div>
                         </div>
                       </div>

                       <div className="col-xl-4 col-lg-6 application_details">
                         <div className="row">
                           <div className="col-4 text-end"><p>Gender</p></div>
                           <div className="col-1 text-center"><p>:</p></div>
                           <div className="col-7">
                             <p>{decryptData(application?.patientData?.gender) || "-"}</p>
                           </div>
                         </div>

                         <div className="row mt-2">
                           <div className="col-4 text-end"><p>Status</p></div>
                           <div className="col-1 text-center"><p>:</p></div>
                           <div className="col-7">
                             <p>{decryptData(application?.patientData?.maritalStatus) || "-"}</p>
                           </div>
                         </div>
                       </div>

                       <div className="col-xl-4 col-lg-6 application_details">
                         <div className="row">
                           <div className="col-4 text-end"><p>DOB</p></div>
                           <div className="col-1 text-center"><p>:</p></div>
                           <div className="col-7">
                             <p>{decryptData(application?.patientData?.birthDate) || "-"}</p>
                           </div>
                         </div>

                         <div className="row mt-2">
                           <div className="col-4 text-end"><p>State</p></div>
                           <div className="col-1 text-center"><p>:</p></div>
                           <div className="col-7">
                             <p>
                             {application.patientData?.address[0].state && decryptData(application.patientData?.address[0].state)}
                             </p>
                           </div>
                         </div>
                       </div>
                     </Row>}
                      </div>
                      <h6 className="form_name list_blk mt-3 mb-3 ">Forms : </h6>
                      <div className="table_space table_listing_color">
                        <div className="table-responsive">
                          <table>
                          <th></th>
                          <th>Form Name</th>
                          <th></th>
                          <th>Updated</th>
                          <th>Status</th>
                          {!isPatient && (<th>Lock Status</th>)}
                          {!isPatient && (<th>Signature Required</th> )}
                            {application?.applicationForms?.length > 0 ? application?.applicationForms.map((form, index)=> (
                            <tbody key={form._id}>
                              <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                <td>{index + 1}</td>
                                <td>
                                  {formEditingIndex === index ? (
                                    <input
                                      type="text"
                                      value={formTitle}
                                      onChange={handleFormTitleChange}
                                      onBlur={() => handleFormTitleSaveClick(index, form._id)} // Save on losing focus
                                    />
                                  ) : (
                                    <span><a
                                    onClick={() => {
                                      if (form?.agreementUrl) {
                                        // Trigger download for agreementUrl
                                        const link = document.createElement("a");
                                        link.href = form.agreementUrl;
                                        link.download = form?.formTitle || "agreement.pdf";
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                      } else {
                                        // Show modal for other cases
                                        setShowPdfViewModal(true);
                                        setPdfUrl(form?.formFile?.signedUrl);
                                        setFormData({ ...form, applicationId: application?._id });
                                      }
                                    }}
                                    className="d-flex flex-column gap-1">{form?.formTitle}</a></span>
                                  )}
                                </td>
                                <td>
                                {!isPatient && form.signatureRequired && !form?.agreementId && form?.status !== formStatus.READY_TO_SIGN && (
                                  <button
                                    className="add_document"
                                    style={{ backgroundColor: "yellow", color: "black" }}
                                    onClick={() =>
                                      form?.status !== formStatus.READY_TO_SIGN &&
                                      handlePrepareForm({ status: formStatus.READY_TO_SIGN, lockStatus: true }, form?._id)
                                    }
                                  >
                                    Prepare For Signature
                                  </button>
                                )}
                                {form.signatureRequired && (!form?.agreementId && form?.status === formStatus.READY_TO_SIGN) && (
                                  <button
                                    className="add_document m-0"
                                    style={{background:"Orange"}}
                                  >
                                    Preparing for Signature
                                  </button>
                                )}
                                {form.signatureRequired && (form?.agreementId && form?.status === formStatus.WAITING_FOR_SIGNATURE) && (
                                  <button
                                    className="add_document"
                                  >
                                    Form Prepared
                                  </button>
                                )}
                                </td>
                                <td>{moment(form?.updatedAt).format("MMM-DD-YYYY")}</td>
                                <td className="p-0 upload_blk">
                                  {isPatient ? (
                                    <span style={{ padding: "0.5rem 1rem", display: "inline-block" }}>
                                      {
                                        // Get the label from the options list
                                        (
                                          (!form.signatureRequired ? statusFormWithoutSignatureOptions : statusFormOptions)
                                            .find((option) => option.value === form?.status)?.label || "-"
                                        )
                                      }
                                    </span>
                                  ) : (
                                    <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                                      <Select
                                        labelId="demo-select-small-label"
                                        id="demo-select-small"
                                        value={form?.status}
                                        defaultValue={form?.status}
                                        onChange={(e) =>
                                          handlePrepareForm({ status: e.target.value }, form?._id)
                                        }
                                        inputProps={{
                                          readOnly: form?.status === formStatus.COMPLETED || form?.status === formStatus.WAITING_FOR_SIGNATURE
                                        }}
                                      >
                                        {(
                                          !form.signatureRequired
                                            ? statusFormWithoutSignatureOptions
                                            : statusFormOptions
                                        ).map((option) => (
                                          <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  )}
                                </td>

                                {!isPatient && (
                                <td>
                                    <div className="toggle">
                                        <input
                                            type="checkbox"
                                            id={`checktoggle-${form._id}`}
                                            disabled={form.status === formStatus.COMPLETED}
                                            onChange={(e) => handleChangeStatus(e, form._id, "lockStatus")}
                                            checked={form?.lockStatus}
                                        />
                                        <label htmlFor={`checktoggle-${form._id}`}></label>
                                    </div>
                                </td>
                                )}
                                {!isPatient && (
                                <td>
                                    <div className="toggle">
                                        <input
                                            type="checkbox"
                                            id={`checktoggle-${form._id}-signature`}
                                            disabled={form.lockStatus || form.status === formStatus.COMPLETED}
                                            onChange={(e) => handleChangeStatus(e, form._id, "signatureRequired", form)}
                                            checked={form?.signatureRequired}
                                        />
                                        <label htmlFor={`checktoggle-${form._id}-signature`}></label>
                                    </div>
                                </td>
                                )}
                                <Dropdown
                                isOpen={dropdownOpen.includes(form?._id)}
                                toggle={() => toggleDropdown(form?._id)}
                              >
                                <DropdownToggle caret size="xl" className="column_blk">
                                  <div className="for_details">
                                    <i className="fa fa-ellipsis-v"></i>
                                  </div>
                                </DropdownToggle>
                                <DropdownMenu>
                                  {/* Edit Button */}
                                  {form.status !=="Completed" && !isPatient &&
                                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                    <div
                                      className={`add_hosp`}
                                      onClick={() => {
                                        handleFormEditClick(index, form?.formTitle);
                                      }}
                                    >
                                      Edit
                                    </div>
                                  </DropdownItem>}

                                  {/* Download Button */}
                                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                    <div
                                      className="add_hosp"
                                      onClick={() =>{
                                        // if (form?.agreementUrl) {
                                        //   // Trigger download for agreementUrl
                                        //   const link = document.createElement("a");
                                        //   link.href = form.agreementUrl;
                                        //   link.download = form?.formTitle || "agreement.pdf";
                                        //   document.body.appendChild(link);
                                        //   link.click();
                                        //   document.body.removeChild(link);
                                        // } else {
                                        form?.formFile?.signedUrl ? handleDownloadForm(form?.formFile?.signedUrl) : null;
                                        // }
                                      }}
                                    >
                                      Download Form
                                    </div>
                                  </DropdownItem>

                                  {/* Upload Button */}
                                  {!isPatient && (
                                  <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                    <div
                                      className={`add_hosp ${form?.lockStatus ? 'disabled' : ''}`}
                                      onClick={() => !form?.lockStatus && triggerFileInputForm(index)}
                                      disabled={form?.lockStatus}
                                    >
                                      Upload
                                    </div>
                                    <input
                                      type="file"
                                      id={`fileInputForm-${index}`}
                                      style={{ display: 'none' }}
                                      onChange={(e) => handleFileSelect(e, form._id, '', 'file')}
                                    />
                                  </DropdownItem>
                                  )}

                                  {!isPatient && (!form?.signatureRequired ||
                                    (form?.signatureRequired &&
                                      (form?.status === formStatus.TO_DO || form?.status === formStatus.IN_PROGRESS))) && (
                                    <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                      <div
                                        className="add_hosp"
                                        onClick={() => handleFormDelete(index, form._id, form?.formTitle)}
                                      >
                                        Delete
                                      </div>
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </Dropdown>
                              </tr>
                              <tr>
                                <td colSpan={8} className="bg_light"></td>
                              </tr>
                            </tbody>))
                             : null}
                          </table>
                        </div>
                        {role !== platformLayout?.Patient &&  <div className="d-flex justify-content-center mt-3">
                          <button className="add_document" onClick={()=> setShowAddFormModal(true)}>Add Form</button>
                        </div>}
                      </div>
                    </div>
                  </AccordionBody>
                </Accordion>
              </TabPane>
              <TabPane tabId="3">
                <Accordion open={open} toggle={toggle}>
                  <AccordionBody accordionId="1" className="form_tab">
                    <div className="data_patient">
                      <div className="row application_details_block application_patient_blk mt-3">
                          <h3 className="title_name mt-0">Application Overview</h3>
                         <div className="col-xl-4 col-lg-4 application_details">
                            <div className="row">
                              <div className="col-3 text-end"><p>Start Date</p></div>
                              <div className="col-1 text-center"><p>:</p></div>
                              <div className="col-8"><p>{moment(application?.createdAt).format("MMM-DD-YYYY")}</p></div>
                            </div>
                          </div>

                          <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Type</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationType?.applicationTitle}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Status</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{stageStatusOption.find(option => option.value === application?.status)?.label || '-'}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-3 text-end"><p>Active Days</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {moment().diff(moment(application?.createdAt), "days") + " Days"}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Consultant</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {application.consultantUser?.[0]
                                  ? `${application.consultantUser?.[0]?.firstName} ${application.consultantUser?.[0]?.lastName}`
                                  : "No Consultant assigned."}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Id</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationID}</p></div>
                          </div>
                        </div>
                        {role !== platformLayout?.Patient && <Row className="mt-3 align-items-center">
                        <h3 className="title_name mt-1">Primary Applicant</h3>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-3 text-end"><p>Name</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {decryptData(application?.patientData?.name[0].text)}{" "}
                                <button
                                  className="add_notes"
                                  onClick={() =>
                                    navigate("/clinic/patient-profile", {
                                      state: {
                                        patientData: application?.patientData?._id,
                                        isEditMode: !prevRoute2 ? true : false,
                                        isEditMode2: prevRoute2 === "/clinic/patient-profile",
                                        application: application
                                      }
                                    })
                                  }
                                >
                                  View Details
                                </button>
                              </p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-3 text-end"><p>Email ID</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {decryptData(
                                  application?.patientData?.telecom.find((obj) => obj?.system === "email")
                                    ?.value || "-"
                                )}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Gender</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.gender) || "-"}</p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-4 text-end"><p>Status</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.maritalStatus) || "-"}</p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>DOB</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.birthDate) || "-"}</p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-4 text-end"><p>State</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                              {application.patientData?.address[0].state && decryptData(application.patientData?.address[0].state)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Row>}
                      </div>
                      <h6 className="form_name list_blk mb-3">Documents: </h6>
                      <div className="table_space table_listing_color">
                        <div className="table-responsive">
                          <table>
                          <th></th>
                          <th>Document Name</th>
                          <th>Document Type</th>
                          <th>Uploaded By</th>
                          <th>Updated</th>
                          <th>Expiration Date</th>
                            {application?.applicationDocuments?.length > 0 && application?.applicationDocuments.map((doc, index)=>(
                            <tbody key={doc?._id}>
                              <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                <td>{index + 1}</td>
                                <td>
                                  {docEditingIndex === index ? (
                                    <input
                                      type="text"
                                      value={docTitle}
                                      onChange={handleDocTitleChange}
                                      onBlur={() => handleDocTitleSaveClick(index, doc.documentId)} // Save on losing focus
                                    />
                                  ) : (
                                    doc?.title
                                  )}
                                </td>
                                <td>{doc?.documentTypeData?.documentTitle}</td>
                                <td>
                                {doc?.uploadedBy?.firstName && doc?.uploadedBy?.lastName
                                  ? `${doc.uploadedBy.firstName} ${doc.uploadedBy.lastName}`
                                  : doc?.uploadedBy?.name?.[0]
                                  ? decryptData(doc.uploadedBy.name[0])
                                  : "-"}
                                </td>
                                <td>{doc?.uploadDate && moment(doc?.uploadDate).format("MMM-DD-YYYY") }</td>
                                <td>
                                {!isPatient && doc?.filePath?.signedUrl &&(
                                 <DatePickerSelector
                                  value={doc.expirationDate ? new Date(doc.expirationDate) : null}
                                  onChange={(date) => handleDocDateChange(date, doc.documentId)}
                                  dateFormat="MMM-dd-yyyy"
                                  minDate={new Date()}
                                  className="form-control"
                                />)}
                                </td>
                                <td className="p-0 icon-actions">
                                  {!isPatient && (
                                    <span
                                      className="material-symbols-outlined"
                                      style={{ cursor: "pointer", marginRight: "8px" }}
                                      onClick={() => handleDocEditClick(index, doc?.title)}
                                    >
                                      edit
                                    </span>
                                  )}

                                  {doc?.filePath?.signedUrl && (
                                    <span
                                      className="material-symbols-outlined"
                                      style={{ cursor: "pointer", marginRight: "8px" }}
                                      onClick={() => handleDownloadDocument(doc.filePath.signedUrl)}
                                    >
                                      download
                                    </span>
                                  )}

                                  <span
                                    className="material-symbols-outlined"
                                    style={{ cursor: "pointer", marginRight: "8px" }}
                                    onClick={() => triggerFileInputDoc(index)}
                                  >
                                    upload
                                  </span>
                                  <input
                                    type="file"
                                    id={`fileInputDoc-${index}`}
                                    style={{ display: "none" }}
                                    onChange={(e) =>
                                      handleFileSelect(e, "", doc?.documentId, "doc")
                                    }
                                  />

                                  {!isPatient && (
                                    <span
                                      className="material-symbols-outlined"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleDocDelete(doc?._id, doc?.title)}
                                    >
                                      delete
                                    </span>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan={8} className="bg_light"></td>
                              </tr>
                            </tbody>)) }
                          </table>
                        </div>
                      </div>
                      {role !== platformLayout?.Patient &&  <div className="d-flex justify-content-center mt-3">
                        <button className="add_document" onClick={()=> setShowAddDocModal(true)}>Add Document</button>
                      </div>}
                    </div>
                  </AccordionBody>
                </Accordion>
              </TabPane>
              <TabPane tabId="4">
                <Accordion open={open} toggle={toggle}>
                  <AccordionBody accordionId="1" className="form_tab">
                    <ReceiptView application={application} patientDetails={patientDetails} getApplication={()=>getApplication()}/>
                  </AccordionBody>
                </Accordion>
              </TabPane>
              <TabPane tabId="5">
                <Accordion open={open} toggle={toggle}>
                  <AccordionBody accordionId="1" className="form_tab">
                   <Tasks getApplication={()=>getApplication()} application={application}/>
                  </AccordionBody>
                </Accordion>
              </TabPane>
              <TabPane tabId="6">
                <Accordion open={open} toggle={toggle}>
                  <AccordionBody accordionId="1" className="form_tab">
                    <Signature getApplication={()=>getApplication()} application={application} activeTab={activeTab} setActiveTab={setActiveTab}/>
                  </AccordionBody>
                </Accordion>
              </TabPane>
              <TabPane tabId="7">
                {!isComposeText ?
               <AddText getApplication={()=>getApplication()} application={application} setIsComposeText={setIsComposeText}/>
               :
               <ComposeMessage getApplication={()=>getApplication()} application={application} setIsComposeText={setIsComposeText}/>}
              </TabPane>
              <TabPane tabId="8">
                <Accordion open={open} toggle={toggle}>
                  <AccordionBody accordionId="1" className="form_tab">
                    {application?._id && <ApplicatioActivity application={application} activeTab={activeTab}/>}
                  </AccordionBody>
                </Accordion>
            </TabPane>
            </TabContent>
          </div>
           <div className="d-flex gap-3 justify-content-center mt-3">
              <button className="save_btn_blockk" type="submit" onClick={()=> navigate(-1)}>Back</button>
          </div>
        </div>
      </div>
      </Fragment>
    );
}

export default ApplicationDetailPage;
